import { StockInputValue_Edit_Option } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/types.ts';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';
import { MODE } from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import klass from './Input_Stock.module.scss';
import { html } from 'rune-ts';
import { Base_Input_Stock } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/Input_Stock/Base_Input_Stock.ts';

interface InputStock_Edit_Option extends InputEditor {
  mode: typeof MODE.EDIT | typeof MODE.EDIT_TPL;
  stock_type: typeof StockType.OPTION_STOCK;
  value: StockInputValue_Edit_Option[];
}

export class Input_Stock_EditOption extends Base_Input_Stock<InputStock_Edit_Option> {
  protected override inputTemplate() {
    return html`
      <div class="${klass.stock_table} ${klass.edit_option}">
        <div class="${klass.row} ${klass.header}">
          <div class="${klass.col}">품목</div>
          <div class="${klass.col}">추가 금액</div>
          <div class="${klass.col}">재고</div>
          <div class="${klass.col}">판매 수량</div>
          <div class="${klass.col}">재고관리 번호</div>
        </div>
        ${this.data.value.map((item) => {
          return html`
            <div class="${klass.row}">
              <div class="${klass.col} ${klass.wide}">${item.name}</div>
              <div class="${klass.col}">${item.price}</div>
              <div class="${klass.col}">${item.stock}</div>
              <div class="${klass.col}">${item.sold_quantity}</div>
              <div class="${klass.col}">${item.sku}</div>
            </div>
          `;
        })}
      </div>
    `;
  }
}
